import { Snackbar } from "@material-ui/core";
import { TextField } from "@material-ui/core";

import { useDispatch } from "react-redux";

import { useEffect, useState } from "react";

import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import UtilsFormule from "../../utils/UtilsFormule";
import { useNavigate } from "react-router-dom";
import ManufacturingBatch from "./ManufacturingBatch";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";

const AddManufacturingBatch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [name, setName] = useState();
  const [serialNumber, setSerialNumber] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    if (startDate === ":59") {
      setStartDate("any");
    }
    if (endDate === ":59") {
      setEndDate("any");
    }
  }, [startDate, endDate]);

  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onChangeSerialNumberHandler = (event) => {
    setSerialNumber(event.target.value);
  };

  // const onChangeStartDate = (event) => {
  //   setStartDate(event.target.value.concat(":59"));
  // };
  const onChangeStartDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the value already includes time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // Append ":00" to the existing time
      : selectedValue + "T00:00:00"; // Add default start time with seconds for date input

    setStartDate(updatedValue);
  };

  // const onChangeEndDate = (event) => {
  //   setEndDate(event.target.value.concat(":59"));
  // };
  const onChangeEndDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the value already includes time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // Append ":59" to the existing time
      : selectedValue + "T23:59:59"; // Add default end time with seconds for date input

    setEndDate(updatedValue);
  };

  const onValidFamilyHandler = () => {
    if (serialNumber == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le numéro de série est vide ! ");
    } else if (startDate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le DLC est vide ! ");
    } else if (endDate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le DLE est vide ! ");
    } else {
      let model = {
        serialNumber: serialNumber,
        dlc: startDate,
        dle: endDate,
        idUserCreation: getCurrentUserId(),
      };

      ManufacturingBatchService.addManufacturingBatche(model).then((result) => {
        if (result.data["manufacturingBatch"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/Lots`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      });
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Lots</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un lot</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Numéro de série</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeSerialNumberHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date de fabrication</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={startDate}
                          onChange={onChangeStartDate}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date d'expiration</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={endDate}
                          onChange={onChangeEndDate}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidFamilyHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      {/* {onConfirmAddFamily && (
        <ConfirmAddFamily
          setOnConfirmAddFamily={setOnConfirmAddFamily}
          confirmFamilyModel={confirmFamilyModel}
          setIsCancel={setIsCancel}
        />
      )} */}
    </div>
  );
};
export default AddManufacturingBatch;
